
import React from 'react';
import { ETicketMobileDisplay } from '../etickets';

import type { ETicketDisplay } from '../../../tsrestapi/models';

import TranslatorManager from 'ts-translate-js';
const tr = TranslatorManager.boundTR;

interface ETicketMobileDisplayListProps {
    eticketDisplays: ETicketDisplay[]
}

export function ETicketMobileDisplayList({ eticketDisplays }: ETicketMobileDisplayListProps) {
    let i = 1;
    let totalNumbering = eticketDisplays.length;

    const etickets = eticketDisplays.map(function(eticket){
        eticket.Numbering = i + "/" + totalNumbering;
        i = i + 1;
        return <ETicketMobileDisplay eticketDisplay={eticket} key={eticket.PassNumber} />;
    }.bind(this));

    return <div>
        <div className="container">
            <br/>
            <div className="eticketMobileWarning text-right col-xs-12 col-sm-8 col-md-6 col-lg-6 col-sm-offset-2 col-md-offset-3">
                {/* TODO: Refactor this as a button */}
                {/* eslint-disable-next-line sonarjs/anchor-is-valid */}
                <a href='' onClick={(e) => { e.preventDefault(); e.stopPropagation(); window.print(); }}>{tr("Version imprimable")}</a>
            </div>
            <div className="eticketMobileWarning col-xs-12 col-sm-8 col-md-6 col-lg-6 col-sm-offset-2 col-md-offset-3">
                <div className="alert alert-danger">{tr("Veuillez augmenter votre luminosité")}</div>
            </div>
        </div>
        {etickets}
    </div>;
}